export const parse = value => (value ? JSON.parse(decodeURI(atob(value))) : {});
export const compile = (value = {}) => btoa(encodeURI(JSON.stringify(value)));
